import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs';
import { LoggingService } from '../services';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  loggingService = inject(LoggingService);
  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (!event.url.includes('.json') && !event.url.includes('/details')) {
            this.loggingService.log('Response:');
            this.loggingService.log(event);
          }
        }
      }),
    );
  }
}
